import * as React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { withRouter } from 'next/router';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { buttonStyles } from '../../styles/base';
import { Button } from '@material-ui/core';
import Link from 'next/link';
import {
  MapPin,
  Phone,
  EnvelopeSimple,
  ArrowRight,
  ChatCircleDots,
} from 'phosphor-react';

import Cta from '../../components/utility/Cta';
import PageBase from '../../components/layout/PageBase';
import ContactForm from '../../components/pages/contact/ContactForm';

import styles from '../../styles/sass/pages/Contact.module.scss';
import { schedulingLink } from '../../lib/constants';
import { formatUtmParams } from '../../lib/helpers';
import track from '../../lib/track';
import combineStyles from '../../styles/combineStyles';

export interface Props {
  classes: any;
  router: any;
  user: any;
  utmCampaign: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;
}

const extraStyles = createStyles({
  chatButton: {
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#463264',
    },
    backgroundColor: '#ffffff',
    border: '1px solid #463264',
    borderRadius: '16px',
    boxShadow: 'none',
    color: '#463264',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    height: '48px',
    lineHeight: '32px',
    marginTop: '16px',
    padding: '8px 16px',
    textTrasnform: 'none',
    width: 'auto',
  },
});
export const Contact = (props: Props) => {
  const { classes, user } = props;
  const contactQuery = get(props.router, 'query', '{}');
  const formInitialValues = Object.assign({}, contactQuery);
  if (Object.keys(user).length !== 0) {
    if (!formInitialValues.email) {
      formInitialValues.email = user.displayEmail || user.email;
    }
    formInitialValues.firstName = user.firstName;
    formInitialValues.firstName = user.lastName;
  }

  React.useEffect(() => {
    track.trackPage('Contact');
  }, []);

  return (
    <PageBase disableOverflow>
      <div className={`page-container ${styles.contactUs} row`}>
        <div className={styles.contactBlob1} />
        <div className={styles.contactBlob2} />
        <div className={styles.contactBlob3} />

        <div className={styles.containerWrap}>
          <div className={styles.sectionTitleWrap}>
            <h2 className={styles.sectionTitle}>Contact Us</h2>
            <p className={styles.subText}>
              Any questions? Just write us a message!
            </p>
          </div>

          <div className={styles.formContainerWrap}>
            <div className={styles.formRow}>
              <div className={styles.heroCard}>
                <div className={styles.heroInner}>
                  <ContactForm initialValues={formInitialValues} />
                </div>
              </div>
              <div className={styles.heroCard}>
                <div className={styles.heroInner}>
                  <h3 className={styles.cardTitle}>Get in touch</h3>
                  <div className={styles.subText}>
                    We’d love to hear from you. Our team is always ready to
                    chat.
                  </div>
                  <div className={styles.addressLine}>
                    <MapPin
                      size={22}
                      color="#2D2332"
                      weight="fill"
                      style={{ marginRight: 5 }}
                    />
                    Massachusetts
                  </div>
                  <div className={styles.addressLine}>
                    <Phone
                      size={22}
                      color="#2D2332"
                      weight="fill"
                      style={{ marginRight: 5 }}
                    />
                    (781) 296-6446
                  </div>
                  <div className={styles.addressLine}>
                    <EnvelopeSimple
                      size={22}
                      color="#2D2332"
                      weight="fill"
                      style={{ marginRight: 5 }}
                    />
                    info@toriihomes.com
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.formRow} style={{ marginBottom: '24px' }}>
              <h3 className={styles.subTitle}>
                Looking for resources or support?
              </h3>
            </div>

            <div className={`${styles.formRow} ${styles.tabCols}`}>
              <div className={`${styles.heroCard} ${styles.transBorder}`}>
                <div className={styles.heroInner}>
                  <div className={styles.supportBlock}>
                    <h3 className={styles.title}>General Inquiries</h3>
                    <p className={styles.desc}>
                      Check out our Frequently Asked Questions to get answers to
                      commonly asked questions
                    </p>
                    <Link href="/buying-with-torii?focus=faq">
                      <a>
                        <ArrowRight
                          size={32}
                          color="#2D2332"
                          style={{ marginRight: 5 }}
                        />
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
              <div className={`${styles.heroCard} ${styles.transBorder}`}>
                <div className={styles.heroInner}>
                  <div className={styles.supportBlock}>
                    <h3 className={styles.title}>For Agents</h3>
                    <p className={styles.desc}>
                      Looking to learn why Torii is different?
                    </p>
                    <Link href="/join?focus=torii-feautres">
                      <a>
                        <ArrowRight
                          size={32}
                          color="#2D2332"
                          style={{ marginRight: 5 }}
                        />
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageBase>
  );
};

const combinedStyles = combineStyles(buttonStyles, extraStyles);

const mapStateToProps = (state: any) => ({
  user: state.auth.user,
  utmCampaign: state.auth.utmCampaign,
  utmMedium: state.auth.utmMedium,
  utmSource: state.auth.utmSource,
  utmTerm: state.auth.utmTerm,
});

export default withStyles(combinedStyles)(
  withRouter(connect(mapStateToProps)(Contact)),
);
